(function () {
    "use strict";

    angular.module('app').factory('codesService', CodesServiceFactory);

    CodesServiceFactory.$inject = ['codesServiceBase'];
    function CodesServiceFactory(codesServiceBase) {
        const extended = angular.extend({}, codesServiceBase);

        return extended;
    }
})();
